<template>
  <div :class="$style.container">
    <div :class="$style['desktop-container']">
      <SidebarDesktopMenu
        @click="handleLinkClick"
        @toggleAccordion="trackAccordionEvent"
      />
      <div :class="$style['right-side']">
        <WayfindingHeader @click="handleLinkClick" />
        <WayfindingFooter />
      </div>
    </div>
    <LegacyFeatureModal v-model:visible="isLegacyModalVisible" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { detectScrollMixin } from '@/utils/vue-mixins';
import analytics from '@/utils/analytics';
import LegacyFeatureModal from '@/components/modals/LegacyFeatureModal.vue';
import WayfindingHeader from '@/components/wayfinding/WayfindingHeader.vue';
import SidebarDesktopMenu from '@/components/menu/SidebarDesktopMenu.vue';
import WayfindingFooter from '@/components/wayfinding/WayfindingFooter.vue';

export default {
  components: {
    WayfindingHeader,
    SidebarDesktopMenu,
    WayfindingFooter,
    LegacyFeatureModal,
  },
  mixins: [detectScrollMixin],
  computed: {
    ...mapGetters([
      'business',
      'productSegmentLabel',
      'userId',
      'showLegacyModal',
    ]),
    isLegacyModalVisible() {
      return this.showLegacyModal;
    },
    eventCommonProps() {
      return {
        targetArea: this.$route.name,
        productSegment: this.productSegmentLabel,
        userId: this.userId,
        businessId: this.business.id,
      };
    },
  },
  methods: {
    trackLinkClickEvent(args) {
      analytics.track(`fe_${args.routeName.replace(/-/g, '_')}_clicked`, {
        ...this.eventCommonProps,
        ...args.eventBadgeProps,
      });
    },
    trackAccordionEvent(details) {
      const name = details.link.toLowerCase().split(' ').join('_');
      analytics.track(`fe_${name}_${details.type}_clicked`, {
        ...this.eventCommonProps,
      });
    },
    handleLinkClick(args) {
      this.trackLinkClickEvent(args);
      this.$router.push({ name: args.routeName }).catch(() => {});
    },
  },
};
</script>

<style lang="less" module>
.container {
  min-height: 100vh;
  min-width: 100%;
  background-color: @color-grey-50;
  position: absolute;
  top: 0;
  left: 0;
}
.desktop-container {
  display: flex;
  flex-direction: row;
}
.right-side {
  flex: 1;
  overflow-y: auto;
  height: 100vh;
  @media only screen and (max-width: @wayfinding-tablet-width) {
    width: 100vw;
  }
  flex-direction: column;
  justify-content: space-between;
  float: right;
  display: flex;
}
</style>
